module.exports = __webpack_public_path__ + "static/media/failed-capture-two.92b7979c.png";